import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const definition = {
    validation: {
        returns: z.object({
            sourceOffset: vector2Like,
            correlation: z.number(),
        }),
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            sourceImageReferencePosition: vector2Like, // reference position in the source image (in pixels)
            templateImage: anyImageOpResult,
            templateImageReferencePosition: vector2Like, // reference position in the template image (in pixels)
            maxSearchRadius: z.number(), // maximum number of pixels to search around the source reference position
            correlationPenaltyPerPixel: z.number().or(vector2Like),
            penaltyDirectionX: vector2Like.optional(),
            // cacheData?: CacheData
            // debugImage?: DebugImage
            // debugRectFn?: (rect: Box2Like, color: string) => void
        }),
    },
}
